import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { GetCalenderByMonthAndYearDto } from 'src/app/core/api/models';
import { UserSessionService } from 'src/app/core/services/authentication/user-session.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { ApiNotificationService } from '../../../../core/services/api-notification.service';
import { DialogService } from '../../../../core/services/dialog.service';
import { CalendarEventDisplayerDirective } from '../calendar-event-displayer.directive';
import { CalendarEventIconDirective } from '../calendar-event-icon.directive';

@Component({
  selector: 'app-calendar-card',
  templateUrl: './calendar-card.component.html',
  imports: [
    MaterialModule,
    NgbModule,
    BaseFormModule,
    CalendarEventDisplayerDirective,
    CalendarEventIconDirective,
  ],
})
export class CalendarCardComponent implements OnInit {
  //#region properties

  @Input() model: GetCalenderByMonthAndYearDto;
  @Input() selected: boolean;
  @Input() todayDate: any;
  @Input() showEventCircle: boolean = true;

  calenderEventsCategories: number[] = [];
  calenderOrganizationEventsCategories: number[] = [];
  totalEventsCategories: number[] = [];

  @Output() selectedDay = new EventEmitter<number>();

  //#endregion

  constructor(
    public apiNotificationService: ApiNotificationService,
    protected userSession: UserSessionService,
    public dialogService: DialogService,
    protected loggerService: LoggerService
  ) {}

  ngOnInit(): void {
    this.calenderEventsCategories = this.model?.calenderEvents.map(
      (event) => event.category
    );

    this.calenderOrganizationEventsCategories =
      this.model?.calenderOrganizationEvents.map((event) => event.category);

    this.totalEventsCategories = this.calenderEventsCategories?.concat(
      this.calenderOrganizationEventsCategories
    );

    this.totalEventsCategories = this.totalEventsCategories?.filter(
      (element, i) => i === this.totalEventsCategories?.indexOf(element)
    );
  }

  onEmitSelectedDay(model) {
    this.selectedDay.emit(model?.solarDate);
  }
}
